<template>
  <q-card>
    <q-card-section class="upload-card">
      <div class="text-subtitle1">{{ title }}</div>
      <slot />
    </q-card-section>
  </q-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="stylus" scoped>
.upload-card {
  display grid
  gap 10px
}
</style>
